import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Server, FileCheck, Eye, AlertCircle } from 'lucide-react';
export function Security() {
  return <section id="security" className="py-24 bg-slate-50" data-id="element-225">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-227">
          {/* Quality Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-228">
            <div className="flex items-center mb-6" data-id="element-229">
              <div className="p-3 bg-amber-100 rounded-lg mr-4" data-id="element-230">
                <FileCheck className="h-6 w-6 text-amber-600" data-id="element-231" />
              </div>
              <h2 className="text-3xl font-serif font-bold text-slate-900" data-id="element-232">
                Quality & Accuracy
              </h2>
            </div>
            <div className="prose prose-slate text-slate-600" data-id="element-233">
              <p className="mb-6" data-id="element-234">
                We don't just rely on raw AI output. Our process is designed for
                legal-grade accuracy with multiple layers of verification.
              </p>
              <ul className="space-y-4 list-none pl-0" data-id="element-235">
                <li className="flex items-start" data-id="element-236">
                  <Eye className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-237" />
                  <span data-id="element-238">
                    <strong data-id="element-239">Structured Prompts:</strong> Each document is
                    reviewed by AI with specific, legally-oriented instructions.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-240">
                  <ShieldCheck className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-241" />
                  <span data-id="element-242">
                    <strong data-id="element-243">Manual QA:</strong> Human quality assurance review
                    is performed before any delivery.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-244">
                  <AlertCircle className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-245" />
                  <span data-id="element-246">
                    <strong data-id="element-247">Flagging System:</strong> Documents are
                    automatically flagged when AI cannot confidently categorize
                    them.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-248">
                  <FileCheck className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-249" />
                  <span data-id="element-250">
                    <strong data-id="element-251">Confidence Scores:</strong> Detailed confidence
                    metrics available upon request for auditability.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Security Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-252">
            <div className="flex items-center mb-6" data-id="element-253">
              <div className="p-3 bg-slate-200 rounded-lg mr-4" data-id="element-254">
                <Lock className="h-6 w-6 text-slate-700" data-id="element-255" />
              </div>
              <h2 className="text-3xl font-serif font-bold text-slate-900" data-id="element-256">
                Data Security
              </h2>
            </div>
            <div className="prose prose-slate text-slate-600" data-id="element-257">
              <p className="mb-6" data-id="element-258">
                Your client's data is handled with the highest standards of
                security and confidentiality.
              </p>
              <ul className="space-y-4 list-none pl-0" data-id="element-259">
                <li className="flex items-start" data-id="element-260">
                  <Lock className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-261" />
                  <span data-id="element-262">
                    <strong data-id="element-263">Encryption:</strong> TLS 1.3 in transit and AES-256
                    at rest on AWS infrastructure.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-264">
                  <Server className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-265" />
                  <span data-id="element-266">
                    <strong data-id="element-267">Data Sovereignty:</strong> All data remains on
                    US-based servers with strict access controls.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-268">
                  <ShieldCheck className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-269" />
                  <span data-id="element-270">
                    <strong data-id="element-271">Private Models:</strong> Enterprise-grade AI models
                    with strict privacy — your data is{' '}
                    <span className="underline decoration-amber-500/50 decoration-2" data-id="element-272">
                      never
                    </span>{' '}
                    used for model training.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-273">
                  <FileCheck className="h-5 w-5 text-slate-400 mr-3 mt-1" data-id="element-274" />
                  <span data-id="element-275">
                    <strong data-id="element-276">Confidentiality:</strong> Standard NDA available
                    upon request.
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}